module.exports = __webpack_public_path__ + "img/background-dots-lg.a196667.jpg";